<form class="example-form">
  <mat-form-field class="example-full-width" appearance="outline">
    <mat-label>Значение</mat-label>
    <input
      type="text"
      placeholder="Значение"
      matInput
      [formControl]="control"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
      <mat-option *ngFor="let option of filteredValues" [value]="option">
        {{ option }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
